export default __webpack_public_path__ + "static/media/eetlijst.b1e64059.png";